import React from 'react'
import { FormattedMessage } from 'react-intl'
import { identity } from 'lodash'

export const Trad = (props) => <FormattedMessage {...props}>{identity}</FormattedMessage>
